
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
h1, h2, h3, h4, h5, h6 {
    margin:0px;
}

:host([site='BH']) h1, :host([site='BH']) h2, :host([site='BH']) h3, :host([site='BH']) h5, :host([site='BH']) h6 {
    font-family:var(--bh-ff-body);
}

:host([site='BH']) h1, :host([site='BH']) h2, :host([site='BH']) h3 {
    font-weight:var(--fw-light);
}

:host([site='BH']) h5, :host([site='BH']) h6 {
    font-weight:var(--fw-bold);
}

:host([site='BH']) h1 {
    font-size:var(--bh-fs-heading-07);
    line-height:var(--bh-lh-heading-07);
    letter-spacing:var(--bh-ls-heading-07);
}

:host([site='BH']) h2 {
    font-size:var(--bh-fs-heading-06);
    line-height:var(--bh-lh-heading-06);
    letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) h3 {
    font-size:var(--bh-fs-heading-05);
    line-height:var(--bh-lh-heading-05);
    letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) h4 {
    font-family:var(--bh-ff-display);
}

:host([site='BH']) h4 {
    font-size:var(--bh-fs-heading-04);
    line-height:var(--bh-lh-heading-04);
    letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) h4 {
    font-weight:var(--fw-normal);
}

:host([site='BH']) h5 {
    font-size:var(--bh-fs-heading-03);
    line-height:var(--bh-lh-heading-03);
    letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) h6 {
    font-size:var(--bh-fs-heading-02);
    line-height:var(--bh-lh-heading-02);
    letter-spacing:var(--bh-ls-heading-02);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h1.outline-font--h2, :host([site='BH']) h1.outline-font--h3, :host([site='BH']) h1.outline-font--h5, :host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h1, :host([site='BH']) h6.outline-font--h2, :host([site='BH']) h6.outline-font--h3, :host([site='BH']) h6.outline-font--h5, :host([site='BH']) h6.outline-font--h6 {
    font-family:var(--bh-ff-body);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h1.outline-font--h2, :host([site='BH']) h1.outline-font--h3, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h6.outline-font--h1, :host([site='BH']) h6.outline-font--h2, :host([site='BH']) h6.outline-font--h3 {
    font-weight:var(--fw-light);
}

:host([site='BH']) h1.outline-font--h5, :host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h5, :host([site='BH']) h6.outline-font--h6 {
    font-weight:var(--fw-bold);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h6.outline-font--h1 {
    font-size:var(--bh-fs-heading-07);
    line-height:var(--bh-lh-heading-07);
    letter-spacing:var(--bh-ls-heading-07);
}

:host([site='BH']) h1.outline-font--h2, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h6.outline-font--h2 {
    font-size:var(--bh-fs-heading-06);
    line-height:var(--bh-lh-heading-06);
    letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) h1.outline-font--h3, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h6.outline-font--h3 {
    font-size:var(--bh-fs-heading-05);
    line-height:var(--bh-lh-heading-05);
    letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
    font-family:var(--bh-ff-display);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
    font-size:var(--bh-fs-heading-04);
    line-height:var(--bh-lh-heading-04);
    letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
    font-weight:var(--fw-normal);
}

:host([site='BH']) h1.outline-font--h5, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h6.outline-font--h5 {
    font-size:var(--bh-fs-heading-03);
    line-height:var(--bh-lh-heading-03);
    letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h6 {
    font-size:var(--bh-fs-heading-02);
    line-height:var(--bh-lh-heading-02);
    letter-spacing:var(--bh-ls-heading-02);
}

:host([site='GHS']) h1, :host([site='GHS']) h2, :host([site='GHS']) h3, :host([site='GHS']) h4, :host([site='GHS']) h5, :host([site='GHS']) h6 {
    font-family:var(--ff-display);
}

h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
    font-size:var(--fs-h1-small);
    line-height:var(--lh-h1-small);
}

@media (min-width: 768px) {

    h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
        font-size:var(--fs-h1-medium);
        line-height:var(--lh-h1-medium);
    }
}

@media (min-width: 1024px) {

    h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
        font-size:var(--fs-h1);
        line-height:var(--lh-h1);
    }
}

h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
    font-size:var(--fs-h2-small);
    line-height:var(--lh-h2-small);
}

@media (min-width: 768px) {

    h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
        font-size:var(--fs-h2-medium);
        line-height:var(--lh-h2-medium);
    }
}

@media (min-width: 1024px) {

    h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
        font-size:var(--fs-h2);
        line-height:var(--lh-h2);
    }
}

h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
    font-size:var(--fs-h3-small);
    line-height:var(--lh-h3-small);
}

@media (min-width: 768px) {

    h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
        font-size:var(--fs-h3-medium);
        line-height:var(--lh-h3-medium);
    }
}

@media (min-width: 1024px) {

    h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
        font-size:var(--fs-h3);
        line-height:var(--lh-h3);
    }
}

h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
    font-size:var(--fs-h4-small);
    line-height:var(--lh-h4-small);
}

@media (min-width: 768px) {

    h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
        font-size:var(--fs-h4-medium);
        line-height:var(--lh-h4-medium);
    }
}

@media (min-width: 1024px) {

    h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
        font-size:var(--fs-h4);
        line-height:var(--lh-h4);
    }
}

h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
    font-size:var(--fs-h5-small);
    line-height:var(--lh-h5-small);
}

@media (min-width: 768px) {

    h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
        font-size:var(--fs-h5-medium);
        line-height:var(--lh-h5-medium);
    }
}

@media (min-width: 1024px) {

    h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
        font-size:var(--fs-h5);
        line-height:var(--lh-h5);
    }
}

h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
    font-size:var(--fs-h6-small);
    line-height:var(--lh-h6-small);
}

@media (min-width: 768px) {

    h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
        font-size:var(--fs-h6-medium);
        line-height:var(--lh-h6-medium);
    }
}

@media (min-width: 1024px) {

    h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
        font-size:var(--fs-h6);
        line-height:var(--lh-h6);
    }
}

.outline-text--base {
    font-size:var(--fs-base) !important;
    line-height:var(--lh-base) !important;
}

.outline-text--xs {
    font-size:var(--fs-xs) !important;
    line-height:var(--lh-xs) !important;
}

.outline-text--sm {
    font-size:var(--fs-sm) !important;
    line-height:var(--lh-sm) !important;
}

.outline-text--lg {
    font-size:var(--fs-lg) !important;
    line-height:var(--lh-lg) !important;
}

.outline-text--lg.mobile {
    font-size:var(--fs-base) !important;
    line-height:var(--lh-base) !important;
}

.outline-text--xl {
    font-size:var(--fs-xl) !important;
    line-height:var(--lh-xl) !important;
}

.outline-text--xl.mobile {
    font-size:var(--fs-base) !important;
    line-height:var(--lh-base) !important;
}

.outline-text--2xl {
    font-size:var(--fs-2xl) !important;
    line-height:var(--lh-2xl) !important;
}

.outline-text--2xl.mobile {
    font-size:var(--fs-lg) !important;
    line-height:var(--lh-lg) !important;
}

.outline-text--3xl {
    font-size:var(--fs-3xl) !important;
    line-height:var(--lh-3xl) !important;
}

.outline-text--3xl.mobile {
    font-size:var(--fs-lg) !important;
    line-height:var(--lh-lg) !important;
}

.outline-text--4xl {
    font-size:var(--fs-4xl) !important;
    line-height:var(--lh-4xl) !important;
}

.outline-text--4xl.mobile {
    font-size:var(--fs-xl) !important;
    line-height:var(--lh-xl) !important;
}

.outline-text--5xl {
    font-size:var(--fs-5xl) !important;
    line-height:var(--lh-5xl) !important;
}

.outline-text--5xl.mobile {
    font-size:var(--fs-2xl) !important;
    line-height:var(--lh-2xl) !important;
}

.outline-text--6xl {
    font-size:var(--fs-6xl) !important;
    line-height:var(--lh-6xl) !important;
}

.outline-text--6xl.mobile {
    font-size:var(--fs-3xl) !important;
    line-height:var(--lh-3xl) !important;
}

.outline-text--7xl {
    font-size:var(--fs-7xl) !important;
    line-height:var(--lh-7xl) !important;
}

.outline-text--7xl.mobile {
    font-size:var(--fs-4xl) !important;
    line-height:var(--lh-4xl) !important;
}

.outline-text--8xl {
    font-size:var(--fs-8xl) !important;
    line-height:var(--lh-8xl) !important;
}

.outline-text--8xl.mobile {
    font-size:var(--fs-5xl) !important;
    line-height:var(--lh-5xl) !important;
}

.outline-text--9xl {
    font-size:var(--fs-9xl) !important;
    line-height:var(--lh-9lx) !important;
}

.outline-text--9xl.mobile {
    font-size:var(--fs-6xl) !important;
    line-height:var(--lh-6xl) !important;
}

.outline-font--thin {
    font-weight:var(--fw-extralight);
}

.outline-font--extralight {
    font-weight:var(--fw-thin);
}

.outline-font--light {
    font-weight:var(--fw-light);
}

.outline-font--normal {
    font-weight:var(--fw-normal);
}

.outline-font--semibold {
    font-weight:var(--fw-semibold);
}

.outline-font--bold {
    font-weight:var(--fw-bold);
}

.outline-font--extrabold {
    font-weight:var(--fw-extrabold);
}

.outline-font--black {
    font-weight:var(--fw-black);
}

:host {
    display:block;
}

:host([site='BH']) {
    color:var(--bh-neutral-darker);
}

:host([site='BH']):host([inherit-color]){
    color:inherit !important;
  }

:host([site='BH']) .border {
    border-width:0px;
}

:host([site='BH']) .border {
    border-bottom-width:1px;
}

:host([site='BH']) .border {
    border-style:solid;
}

:host([site='BH']) .border {
    border-color:var(--bh-neutral-light);
}

:host([site='BH']) h1.border {
    margin-bottom:2rem;
}

:host([site='BH']) h1.border {
    padding-bottom:2rem;
}

:host([site='BH']) h2.border {
    margin-bottom:1.5rem;
}

:host([site='BH']) h2.border {
    padding-bottom:1.5rem;
}

:host([site='BH']) h3.border {
    margin-bottom:1rem;
}

:host([site='BH']) h3.border {
    padding-bottom:1rem;
}

:host([site='BH']) h4.border {
    margin-bottom:0.5rem;
}

:host([site='BH']) h4.border {
    padding-bottom:0.5rem;
}

:host([site='BH']) h5.border {
    margin-bottom:0.25rem;
}

:host([site='BH']) h5.border {
    padding-bottom:0.25rem;
}

:host([site='BH']) h6.border {
    margin-bottom:0.25rem;
}

:host([site='BH']) ::slotted(a) {
    color:var(--bh-brand-primary-default) !important;
}

:host([site='BH']) ::slotted(a:hover) {
    text-decoration-line:underline !important;
}

:host([site='GHS']) {
    font-family:var(--ff-display);
    color:var(--primary-blue);
}

:host([site='GHS']).text-neutral-white h1, :host([site='GHS']).text-neutral-white h2, :host([site='GHS']).text-neutral-white h3, :host([site='GHS']).text-neutral-white h4, :host([site='GHS']).text-neutral-white h5, :host([site='GHS']).text-neutral-white h6 {
    color:var(--neutral-white);
}

:host([site='GHS']).text-neutral-whiteh1, :host([site='GHS']).text-neutral-whiteh2, :host([site='GHS']).text-neutral-whiteh3, :host([site='GHS']).text-neutral-whiteh4, :host([site='GHS']).text-neutral-whiteh5, :host([site='GHS']).text-neutral-whiteh6{
  }

:host([site='GHS']).text-neutral-white h1:host([site='GHS']), :host([site='GHS']).text-neutral-white h2:host([site='GHS']), :host([site='GHS']).text-neutral-white h3:host([site='GHS']), :host([site='GHS']).text-neutral-white h4:host([site='GHS']), :host([site='GHS']).text-neutral-white h5:host([site='GHS']), :host([site='GHS']).text-neutral-white h6:host([site='GHS']){
  color:inherit;
}

:host([site='GHS']):host([inherit-color]){
    color:inherit !important;
  }

.text-neutral-white:host([site='GHS']){
  color:inherit;
}
`;